import React, { useEffect, useState, useRef } from 'react';
import ProductTag from '../ProductTag';
import { addUpdateCart, addWishlist, checkProductInCart, checkProductInWishlist, removeWishlist } from '@common/utils/cart';
import { Link } from 'react-router-dom';
import CustomCounterWidget from '@common/components/CustomCounterWidget';
import { useProductStatus } from 'hooks/useProductStatus';
import { useProductActions } from 'hooks/useProductActions';
import { isUserLoggedIn } from '@common/utils/auth/authService';
import { useDispatch } from 'react-redux';
import { openSignInModal } from 'store/slices/authSlice';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Autoplay, Pagination } from 'swiper/modules';
import { trackCriteoEvent } from 'utils/criteo';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import { Cloudinary } from '@cloudinary/url-gen';
import { format } from '@cloudinary/url-gen/actions/delivery';

function ProductTile({ thumbnailImages, imageUrl, tagTitle, handleAction, productTitle, priceValue, strikePriceValue, colorVariants, productId = "", productSlug = "", showAddToCart = true, productQty = 0, stock = 0, setCartData, isWishlistActive = false, variant, isOutOfStock = false }) {

    const dispatch = useDispatch();

    // Initialize Cloudinary instance
    const cld = new Cloudinary({
        secure: true,
        cloud: {
            cloudName: 'dci1aiukm'
        }
    });
    const extraColorsCount = colorVariants?.filter(item => item.id !== productId)?.length - 2;
    // const extraColorsCount = colorVariants?.length - 2;

    const { getCartQuantity, getProductInStock, isInWishlist, isInCart, isStockLimitAvailable } = useProductStatus();
    const { toggleWishlist, addToCart, updateCartQuantity } = useProductActions();
    const [wishlistActive, setWishlistActive] = useState(isInWishlist(productId));
    useEffect(() => {
        setWishlistActive(isInWishlist(productId));
    }, [isInWishlist(productId)]);

    const itemProductQty = getCartQuantity(productId);
    const itemProductStock = getProductInStock(productId);

    useEffect(() => {
        setWishlistActive(checkProductInWishlist(productId));
    }, [productId]);

    const wishListActiveHandleChange = async (e, productId, type) => {
        e.preventDefault();
        if (isUserLoggedIn()) {
            toggleWishlist(productId, type);
        } else {
            dispatch(openSignInModal());
        }
        // if (type === 'remove') {
        //     await removeWishlist(productId); // Perform the remove action
        //     setWishlistActive(false); // Update the state to reflect the removal
        // } else {
        //     await addWishlist(productId); // Perform the add action
        //     setWishlistActive(true); // Update the state to reflect the addition
        // }
    };

    const formatINR = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        }).format(amount);
    };

    // cart qty state
    const [qty, setQty] = useState(itemProductQty);

    useEffect(() => {
        setQty(itemProductQty);
    }, [itemProductQty]);

    useEffect(() => {
        if (itemProductQty !== qty) {
            // updateCart(
            //     productId,
            //     qty,
            // )
            // console.log('update qty', qty);

            // addUpdateCart(productId, qty, 'update', setCartData);
            updateCartQuantity(productId, qty);
        }
    }, [qty]);

    // const updateCart = async (id, quantity) => {
    //     try {
    //         const cart = await addUpdateCart(id, quantity, 'update', setCartData); // Await the promise returned by getCart
    //         console.log('cart', cart);
    //         if (cart) {
    //             // setCartData(cart?.data);
    //         }
    //     } catch (error) {
    //         console.error('Error update cart:', error);
    //     }
    // };

    // console.log('getProductInStock(productId)', getProductInStock(productId));

    const swiperRef = useRef(null);
    const [hoverState, setHoverState] = useState(false);

    const tileHoverHandleEnterChange = () => {
        setHoverState(true);
        if (swiperRef.current?.autoplay) {
            swiperRef.current.autoplay.start();
        }
    }

    const tileHoverHandleOutChange = () => {
        setHoverState(false);
        if (swiperRef.current?.autoplay) {
            swiperRef.current.autoplay.stop();
        }
    }

    const autoPlayOptions = {
        delay: 1500,
        disableOnInteraction: false,
        pauseOnMouseEnter: false, // avoid conflicting with manual hover handling
    };

    function trackCriteoAddToCartEvent() {
        let email = null;
        let addToCart = { id: productId, price: priceValue ? priceValue : strikePriceValue, qty: 1 };

        const userInfo = JSON.parse(localStorage.getItem('u_info'), null);
        console.log({ userInfo });


        if (!!userInfo && !userInfo?.firstName?.includes('Guest')) {
            email = userInfo?.email;
        } else {
            email = "GuestUser";
        }
        const events = [
            { event: "addToCart", item: addToCart },
        ];
        trackCriteoEvent(events);
    }


    return (
        <Link
            className='bs-product-tile'
            // to={`https://sansaar-3483.myshopify.com/products/${productSlug}`}
            to={productSlug}
        >
            <div className='bs-product-tile__head-wrap'>
                {tagTitle &&
                    <ProductTag
                        title={tagTitle}
                        classname="bs-product-tile__tag"
                    />
                }

                <div className='bs-product-tile__media-wrap' >
                    {thumbnailImages?.length > 1 ? (
                        <div className='bs-product-tile__media-ring-wrap'>
                            <Swiper
                                ref={swiperRef}
                                speed={1000}
                                spaceBetween={0}
                                centeredSlides={true}
                                autoplay={hoverState ? autoPlayOptions : false}
                                pagination={{
                                    clickable: true,
                                }}
                                modules={[Autoplay, Pagination]}
                                className="mySwiper bs-product-tile__media-ring"
                                onSwiper={(swiper) => {
                                    swiperRef.current = swiper;
                                    swiper.autoplay.stop(); // Start paused
                                }}
                            >
                                {thumbnailImages.map((item, index) => {
                                    return (
                                        <SwiperSlide key={index}>
                                            {/* <CloudinaryAdvancedImage imagePublicId={item?.imageUrl} className='bs-product-tile__image' /> */}
                                            <img src={item?.imageUrl} alt="" />
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                            {/* <CloudinaryAdvancedImage imagePublicId={imageUrl} className='bs-product-tile__image bs-product-tile__image-single' /> */}
                            <img src={imageUrl} alt="" />
                        </div>
                    ) : (
                        // <CloudinaryAdvancedImage imagePublicId={imageUrl} className='bs-product-tile__image' />
                        <img src={imageUrl} alt="" />
                    )}
                </div>
            </div>
            <div className='bs-product-tile__info-wrap'>
                <h3 className='bs-product-tile__title'>{productTitle}</h3>
                <div className='bs-product-tile__more-info-wrap'>
                    <div className='bs-product-tile__price-wrap'>
                        <strong className='bs-product-tile__price'>{priceValue ? formatINR(priceValue) : formatINR(strikePriceValue)}</strong>
                        {priceValue && <strong className='bs-product-tile__price bs-product-tile__price--strike'>{strikePriceValue ? formatINR(strikePriceValue) : ''}</strong>}
                    </div>
                    {colorVariants && <div className='bs-product-tile__color-list-wrap'>
                        {colorVariants.slice(0, 2).map((item, index) => (
                            // <span
                            //     className="bs-product-tile__color-item bs-product-tile__color-item--block"
                            //     style={{ backgroundColor: item.colorCode }}
                            //     key={item.id}
                            // ></span>
                            <img
                                className="bs-product-tile__color-item bs-product-tile__color-item--block"
                                src={cld.image(item.imageUrl).quality('auto').delivery(format('webp')).toURL()}
                                alt={index.slug}
                                key={index}
                            />
                        ))}
                        {extraColorsCount > 0 && (
                            <span className="bs-product-tile__color-item">+{extraColorsCount}</span>
                        )}
                    </div>}
                </div>
            </div>
        </Link>
    )
}

export default ProductTile